import m from 'mithril'
import { css } from '@emotion/css'
import { colors, font, space, card, btnPrimary, input, label } from '../styles/theme.js'
import { adminAuthModel } from '../models/admin-auth.js'

const container = css`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 70vh;
`

const formCard = css`
  ${card};
  width: 100%;
  max-width: 400px;
`

const title = css`
  font-size: ${font.size['2xl']};
  font-weight: ${font.weight.bold};
  margin-bottom: ${space.lg};
  text-align: center;
  color: ${colors.textSecondary};
`

const subtitle = css`
  font-size: ${font.size.sm};
  color: ${colors.textMuted};
  text-align: center;
  margin-bottom: ${space.lg};
`

const fieldGroup = css`
  margin-bottom: ${space.md};
`

const errorMsg = css`
  color: ${colors.critical};
  font-size: ${font.size.sm};
  margin-bottom: ${space.md};
  text-align: center;
`

export function AdminLoginView() {
  let email = ''
  let password = ''

  function submit(e) {
    e.preventDefault()
    adminAuthModel.clearError()
    adminAuthModel.login(email, password)
  }

  return {
    view() {
      return m('div', { class: container }, [
        m('form', { class: formCard, onsubmit: submit }, [
          m('h1', { class: title }, 'Admin'),
          m('p', { class: subtitle }, 'Platform administration'),

          adminAuthModel.error
            ? m('div', { class: errorMsg }, adminAuthModel.error)
            : null,

          m('div', { class: fieldGroup }, [
            m('label', { class: label }, 'Email'),
            m('input', {
              class: input,
              type: 'email',
              value: email,
              oninput: (e) => { email = e.target.value },
              required: true,
            }),
          ]),

          m('div', { class: fieldGroup }, [
            m('label', { class: label }, 'Password'),
            m('input', {
              class: input,
              type: 'password',
              value: password,
              oninput: (e) => { password = e.target.value },
              required: true,
            }),
          ]),

          m('button', {
            class: `${btnPrimary} ${css`width: 100%; justify-content: center;`}`,
            type: 'submit',
          }, 'Sign in'),
        ]),
      ])
    },
  }
}
